/* eslint-disable no-unused-vars */
import _ from "lodash";
import React, { useCallback, useEffect, useState, forwardRef } from "react";
import { URL_API, axios, getToken } from "../../../../utils";
import { Select, Spin } from "antd";

const SelectProduct = forwardRef((props, ref) => {
  const [productOptions, setProductOptions] = useState([]);
  const [fetching, setFetching] = useState(false);

  // ฟังก์ชันยิง API ค้นหาสินค้า
  const fetchProduct = async (searchValue = "") => {
    try {
      setFetching(true);
      const res = await axios({
        method: "get",
        baseURL: URL_API,
        url: `lab-test/lab-test-find-product`,
        headers: { Authorization: "Bearer " + getToken() },
        params: { product_code: searchValue },
      });

      const dataProduct = res.data?.dataProduct || [];

      const data = dataProduct.map((product) => ({
        text: `${product.product_code} ${product.product_name_local || product.product_name_en || ""
          }`,
        value: product.product_code,
      }));

      setProductOptions(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setFetching(false);
    }
  };

  const debounceGetProduct = useCallback(
    _.debounce((value) => {
      fetchProduct(value);
    }, 500),
    []
  );

  useEffect(() => {
    return () => {
      debounceGetProduct.cancel();
    };
  }, [debounceGetProduct]);

  return (
    <Select
      ref={ref}
      showSearch
      labelInValue // แสดงข้อความ label ที่ระบุไว้ใน initialValue
      filterOption={false}
      notFoundContent={fetching ? <Spin size="small" /> : "ไม่พบข้อมูลสินค้า"}
      onSearch={debounceGetProduct}
      onFocus={() => {
        if (productOptions.length === 0) {
          fetchProduct("");
        }
      }}
      className="w-100"
      placeholder="ค้นหาด้วยรหัสสินค้า หรือชื่อสินค้า"
      {...props}
    >
      {productOptions.map((d) => (
        <Select.Option key={d.value} value={d.value} title={d.text}>
          {d.text}
        </Select.Option>
      ))}
    </Select>
  );
});

export default SelectProduct;